import { resetState } from './redux-util/general-helpers';
import { DESTROY } from './redux-jigsaw/jigsaw-methods';
import { createStartAction } from './redux-util/async-helpers';

// https://stackoverflow.com/questions/35622588/how-to-reset-the-state-of-a-redux-store/35641992#35641992

const types = [createStartAction(DESTROY).type];
export function withDestroyViewerReset(handler) {
  return resetState(types, handler);
}
